<template>
<div class="wenjuan-template">
    <div v-if="addFrom === '' && value === ''">
        <el-button type="success" size="mini" @click="addBlank">空白创建</el-button>
    </div>

    <div class="add_btn_list" v-if="addFrom === 1 || value != ''">
        <el-button type="info" size="mini" @click="add('radio')">单选</el-button>
        <el-button type="info" size="mini" @click="add('checkbox')">多选</el-button>
        <el-button type="info" size="mini" @click="add('select')">下拉选择</el-button>
        <el-button type="info" size="mini" @click="add('image')">图片选择</el-button>
        <el-button type="info" size="mini" @click="add('text')">填空</el-button>
        <el-button type="info" size="mini" @click="add('multiple_text')">多项填空</el-button>
        <el-button type="info" size="mini" @click="add('star')">打分</el-button>
        <el-button type="info" size="mini" @click="add('rating')">评价</el-button>
        <el-button type="info" size="mini" @click="add('file')">文件上传</el-button>
        <el-button type="info" size="mini" @click="add('career')">职业</el-button>
        <el-button type="info" size="mini" @click="add('address')">所在地</el-button>
        <el-button type="info" size="mini" @click="add('education')">学历</el-button>
        <el-button type="info" size="mini" @click="add('income')">年收入</el-button>
        <el-button type="info" size="mini" @click="add('phone_brand')">常用手机品牌</el-button>
    </div>
    
    <div v-for="(question, index) in localQuestions" :key="index" class="question-item">
        <div class="question-header">
            <el-tag>{{ index + 1 }}</el-tag>
            <el-input :disabled = "disabled" v-model="question.label" @change="updateQuestion" size="small" />

            <el-button
                v-if = "!disabled"
                @click="changeRequired(index)" 
                size="mini" 
                :type="question.required ? 'success' : 'info'" icon="el-icon-open" 
                circle
            ></el-button>

            <el-button
                v-if = "!disabled"
                type="success"
                @click="duplicateQuestion(index)"
                size="mini"
                icon="el-icon-document-copy"
                circle
            />
            <el-button
                v-if = "!disabled"
                type="danger"
                @click="removeQuestion(index)"
                size="mini"
                icon="el-icon-delete"
                circle
            />
        </div>

        <!-- 单选题/多选题 -->
        <div v-if="['radio','checkbox','select'].includes(question.type)" class="options">
            <div v-for="(opt, optIndex) in question.options" :key="optIndex" class="option">
                <div style=" width: 100%; display: flex; gap: 10px; align-items: center;">
                    <input v-if="['radio','checkbox'].includes(question.type)" :type="question.type" disabled />
                    <i v-if="question.type === 'select'" class="el-icon-caret-bottom"></i>
                    <div class="inputbox">
                        <el-input :disabled = "disabled" @change="updateQuestion" v-model="question.options[optIndex].text" size="medium" />
                        <el-input class="blank_input" v-if="opt.show_input" type="text" disabled size="mini" />
                    </div>
                    <i v-if = "!disabled && ['radio','checkbox'].includes(question.type)" style="cursor: pointer;" @click="showSetting(index,optIndex)" class="el-icon-s-tools"></i>
                    <i v-if = "!disabled" style="cursor: pointer;" @click="removeOption(index,optIndex)" class="el-icon-remove"></i>
                </div>
                <div class="description" v-if="opt && opt.show_description">
                    <el-input :disabled = "disabled" size="mini" v-model="opt.description" @change="updateQuestion" placeholder="请输入选项说明" />
                </div>
            </div>

            <div class="option-actions" v-if = "!disabled">
                <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addOption(index,false,question.type)">添加选项</el-button>
                <el-button v-if="['radio','checkbox'].includes(question.type)" size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addOption(index,true,question.type)">添加其他项</el-button>
                <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="batchOptionsIndex = index,showBatchAdd = true">批量添加选项</el-button>
            </div>
        </div>

        <!-- 输入框 -->
        <div v-if="question.type === 'text'">
            <el-input size="small" placeholder="填写者内容输入区" :disabled="true"></el-input>
        </div>

        <!-- 多项填空题 -->
        <div v-if="question.type === 'multiple_text'">
            <div v-for="(opt, optIndex) in question.options" :key="optIndex" class="option">
                <el-input v-model="opt.text" size="small"></el-input>
                <el-input size="small" placeholder="填写者内容输入区" :disabled="true"></el-input>
            </div>
            <div class="option-actions" v-if = "!disabled">
                <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addOption(index,false,question.type)">添加选项</el-button>
                <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="batchOptionsIndex = index,showBatchAdd = true">批量添加选项</el-button>
            </div>
        </div>

        <!-- 上传图片 -->
        <div class="imges_list" v-if="question.type === 'image'">
            <div v-for="(opt, optIndex) in question.options" :key="optIndex" class="image_box">
                <img :src="opt.src" />
                <!-- <el-input v-model="opt.text" size="small" placeholder="图片描述"></el-input> -->
                <div v-if = "!disabled" class="delete_box"><i @click="removeOption(index,optIndex)" class="el-icon-delete"></i></div>
            </div>
            <el-upload
            class="avatar-uploader"
            :headers="uploadHeaders"
            accept=".png,.jpg,.jpeg"
            :on-success="(response, file, fileList)=> uploadSuc(response, file, fileList, index)"
            :action="URL.detailTask.uploadUrl"
            :show-file-list="false"
            :auto-upload="true"
            multiple
            :before-upload="(file) => uploadProgress(file, 5, '.png,.jpg,.jpeg')"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div class="loading">{{ loading }}</div>
          </el-upload>
        </div>        

        <!-- 文件上传 -->
        <el-button v-if="question.type === 'file'" :disabled="disabled" size="mini" type="primary"><i class="el-icon-upload el-icon--right"></i> 上传文件</el-button>

        <!-- 评分星星 -->
        <el-rate v-if="question.type === 'star'" disabled :value="10" style=" margin-top: 10px;" :max="10" />
        
        <!-- 评分 -->
        <div v-if="question.type === 'rating'" class="ratebox">
            <div class="rate_item" v-for="(item,rateIndex) in 10">{{ item }}</div>
        </div>

        <!-- 其它 -->
        <div v-if="['career','address','education','income','phone_brand'].includes(question.type)" class="select_style">
            <el-select v-model="select" size="small" disabled :placeholder = "labelMap[question.type]" style="width: 100%">
                <el-option label="选项1" value="1" />
            </el-select>
        </div>
    </div>

    <el-dialog class="optbox" width="30%" :title="'第'+ (this.setingIndex+1) + '题选项' + (this.setingOptionsIndex+1) + '选项设置'" :visible.sync="seting" append-to-body>
        <div class="optitem">
            <span>增加选项说明</span>
            <el-switch v-if="localQuestions[setingIndex] && localQuestions[setingIndex].options && localQuestions[setingIndex].options.length > 0" v-model="localQuestions[setingIndex].options[setingOptionsIndex].show_description" active-color="var(--brand-primary)" @change="updateQuestion"></el-switch>
        </div>
        <div class="optitem">
            <span>选项后增加填空框</span>
            <el-switch v-if="localQuestions[setingIndex] && localQuestions[setingIndex].options && localQuestions[setingIndex].options.length > 0" v-model="localQuestions[setingIndex].options[setingOptionsIndex].show_input" active-color="var(--brand-primary)" @change="updateQuestion"></el-switch>
        </div>
    </el-dialog>

    <el-dialog title="批量添加选项(每行代表一个选项)" class="batch-add-modal" :visible.sync="showBatchAdd" append-to-body>
        <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="batchOptionsText"></el-input>
        <div style="margin-top: 10px; display: flex;">
            <el-button size="small" type="primary" @click="addBatchOptions">确认添加</el-button>
            <el-button size="small" type="info" @click="batchOptionsIndex = 0,showBatchAdd = false">取消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import URL from '@/views/business/util/url'
export default {
    props: ['value','disabled','uploadHeaders','addFrom'],
    data() {
        return {
            localQuestions: this.parseQuestions(this.value),
            batchOptionsIndex: 0,
            batchOptionsText: "",
            showBatchAdd: false,
            seting: false,
            setingIndex: 0,
            setingOptionsIndex: 0,
            labelMap: {
                radio: "请选择一个选项",
                checkbox: "请选择以下选项（多选）",
                select: "请选择一个选项",
                text: "请填写以下内容",
                multiple_text: "请填写以下内容",
                image: "请选择图片",
                file: "请上传文件",
                star: "请您给问卷打分",
                rating: "您对问卷的满意度如何？",
                career: "请选择职业",
                address: "请选择所在地",
                education: "请选择学历",
                income: "请选择年收入",
                phone_brand: "请选择常用手机品牌"
            },
            URL,
            loading: "",
            select: []
        }
    },
    methods: {
        uploadSuc(response, file, fileList, index){
            if (response.code == 0){
                let options = {
                    src: response.result
                }
                this.localQuestions[index].options.push(options)
                this.loading = "";
            } else {
                console.log("====上传失败")
                this.loading = window.$t('page.uploadFail');
            }
            this.$forceUpdate();
            this.updateQuestion();
        },
        uploadProgress(file, maxfileSize = 1024, accept = ''){
            const fileSize = file.size / 1024 / 1024;
            if (accept) {
                const extension = accept.split(',').map(item => item.replace('.',''));
                const fileType = file.type.split('/')[1];
                if (!extension.includes(fileType)){
                    this.$message.error(`只能上传${accept}格式图片`);
                    return false;
                }
            }
            if (fileSize > maxfileSize) {
                this.$message.error(`文件大小不能超过${maxfileSize}M`);
                return false;
            }
            this.loading = window.$t('page.uploading');
            this.$forceUpdate();
        },
        updateQuestion() {
            this.localQuestions.forEach((item, index) => {
                this.$set(item, 'id', index + 1);
            });
            this.$emit('input', JSON.stringify(this.localQuestions))
        },
        add(type) {
            let question = {
                type: type,
                label: this.labelMap[type],
                required: true,
            }
            if (type === 'radio' || type === 'checkbox') {
                question.options = [{ text: "选项1", show_description: false },{ text: "选项2", show_description: false }];
            } else if (type === 'select') {
                question.options = [{ text: "选项1" },{ text: "选项2" }];
            } else if (type === 'multiple_text') {
                question.options = [{ text: "填空1" },{ text: "填空2" }];
            } else if (type === 'image') {
                question.options = [];
            }
            this.localQuestions.push(question);
            this.updateQuestion();
        },
        parseQuestions(value) {
            try {
                const parsed = JSON.parse(value);
                if (typeof parsed === 'object' && parsed !== null) {
                    return parsed;
                }
                throw new Error();
            } catch {
                return []
            }
        },
        addBlank() {
            this.localQuestions = [];
            this.$emit('changeAddFrom', 1);
        },
        addOption(index,val = false,type) {
            let options = {
                text: val ? '其他' : `选项${this.localQuestions[index].options.length + 1}`,
                show_description: false,
                description: '',
                show_input: val
            }
            if (type === 'multiple_text') {
                options = { text: `填空${this.localQuestions[index].options.length + 1}`}
            }
            if (type === 'select') {
                options = { text: `选项${this.localQuestions[index].options.length + 1}`}
            }
            this.localQuestions[index].options.push(options)
            this.updateQuestion()
        },
        changeRequired (index){
            this.localQuestions[index].required = !this.localQuestions[index].required
            this.updateQuestion()
        },
        duplicateQuestion(index) {
            this.$confirm('确定复制该问题吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                const original = this.localQuestions[index];
                const newQuestion = {
                    ...original,
                    label: `${original.label}(副本)`
                }
                this.localQuestions.splice(index + 1, 0, newQuestion)
                this.updateQuestion()
            }).catch(() => {
            });
        },
        removeQuestion(index) {
            this.$confirm('确定删除该问题吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.localQuestions.splice(index, 1)
                this.updateQuestion()
            }).catch(() => {
            });
        },
        removeOption(index, optindex) {
            this.$confirm('确定删除该选项吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.localQuestions[index].options.splice(optindex, 1)
                this.updateQuestion()
            }).catch(() => {
            });
        },
        addBatchOptions() {
            if (this.batchOptionsText.trim()) {
                let options = this.batchOptionsText.split('\n')
                .map(line => line.trim())
                .filter(Boolean)
                .map(text => ({
                    text
                }));

                if (options.length > 0) {
                    this.localQuestions[this.batchOptionsIndex].options.push(...options)
                    this.updateQuestion()
                }                
            }
            this.batchOptionsIndex = 0;
            this.showBatchAdd = false;
            this.batchOptionsText = '';
        },
        showSetting(index,optIndex){
            this.seting = true;
            this.setingIndex = index;
            this.setingOptionsIndex = optIndex;
        },
    },
    watch: {
      value: {
        handler(newVal) {
            this.localQuestions = this.parseQuestions(newVal)
        },
        deep: true
      }
    }
}
</script>

<style scoped>
.add_btn_list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 15px;
    justify-content: flex-start;
    gap: 10px 10px;
}
.add_btn_list .el-button {
    margin: 0;
}
.question-item {
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #eee;
}
.question-header {
    display: flex;
    align-items: center;
    gap: 10px;
}
.question-header button{
    margin: 0;
}
.options {
    margin-top: 10px;
}
.option {
    width: 100%;
    display: flex;
    margin-bottom: 5px;
    flex-wrap: wrap;
}
.option .inputbox {
    position: relative;
    flex: 1;
}
.option .inputbox >>> input {
    box-sizing: border-box;
    padding-right: 95px;
}
.option .inputbox .blank_input >>> input {
    padding: 0;
}
.option .description {
    width: 100%; 
    box-sizing: border-box; 
    padding-left: 23px;
}
.option .description >>> input {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
}
.option .inputbox .blank_input {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translate(0,-50%);
    width: 80px;
}
.optbox >>> .el-dialog,.batch-add-modal >>> .el-dialog {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
}
.optbox .optitem {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}
.option-actions {
    display: flex;
}
.ratebox {
    display: flex;
    padding: 10px 0 5px 0;
    gap: 5px;
}
.ratebox .rate_item {
    border: solid 1px #E4E7ED;
    border-radius: 100%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.question-item .imges_list {
    margin-top: 5px;
    display: flex;
}
.question-item .imges_list .image_box {
    width: 78px;
    display: flex;
    flex-wrap: wrap;
    margin-right: 5px;
    position: relative;
}
.question-item .imges_list .image_box img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
    display: block;
}
.question-item .imges_list .image_box .delete_box {
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 78px;
    height: 78px;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    display: none;
}
.question-item .imges_list .el-icon-delete {
    font-size: 26px;
    color: #fff;
    cursor: pointer;
}
.question-item .imges_list .image_box:hover .delete_box {
    display: flex;
}
.question-item .imges_list >>> .el-input__inner {
    padding: 0 10px;
    text-align: center;
}
.question-item .imges_list >>> .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    font-size: 28px;
    color: #8c939d;
    width: 78px;
    height: 78px;
    line-height: 78px;
    text-align: center;
}
.question-item .imges_list >>> .avatar-uploader-icon:hover {
    border-color: var(--brand-primary);
}
.question-item .imges_list >>> .avatar {
    width: 78px;
    height: 78px;
    display: block;
}
</style>